// extracted by mini-css-extract-plugin
export default {"list":"E6jjcn","listItem":"Zc7IjY","row":"VM7gjN"};